import { ArrowRight, Linkedin } from "lucide-react";
import { LINKEDIN_URL, PORTRAIT_IMAGE } from "./data";
import { Reveal } from "./Reveal";

export function AboutSection({ onBook }) {
  return (
    <section className="section container about-section" id="about">
      <Reveal>
        <div className="section-label"><span className="chapter-no">02</span>Meet your specialist</div>
        <div className="section-head about-head">
          <p className="lead">Dr. Sreeniketh Reddy is a Consultant Urologist, Andrologist and Robotic Surgeon practising across two convenient Hyderabad locations.</p>
          <div className="about-actions">
            <a className="text-link" data-testid="about-profile-link" href="/dr-sreeniketh-reddy/">View full profile <ArrowRight size={17} /></a>
            <a className="text-link" data-testid="about-linkedin-link" href={LINKEDIN_URL} target="_blank" rel="noreferrer"><Linkedin size={17} /> LinkedIn</a>
            <button className="text-link" data-testid="about-appointment-link" onClick={onBook}>Plan a visit <ArrowRight size={17} /></button>
          </div>
        </div>
      </Reveal>
      <Reveal delay={0.12}>
        <div className="profile-card">
          <img data-testid="profile-doctor-image" src={PORTRAIT_IMAGE} alt="Dr. Sreeniketh Reddy, urologist and robotic surgeon at MEDICOVER Hospitals Hitec City and LUX Hospitals Gachibowli" />
          <div>
            <span className="eyebrow">Consultant specialist</span>
            <h3>Dr. Sreeniketh Reddy</h3>
            <div className="profile-details">
              <div className="profile-detail" data-testid="profile-qualifications"><span className="detail-label">Qualifications</span><p><strong>M.S, M.Ch UROLOGY</strong><br />Fellowship in Laparoscopic, Robotic and Renal Transplant Surgery</p></div>
              <div className="profile-detail" data-testid="profile-designation"><span className="detail-label">Designation</span><p>Consultant Urologist, Andrologist and Robotic Surgeon</p></div>
              <div className="profile-detail" data-testid="profile-workplaces"><span className="detail-label">Practicing at</span><p>MEDICOVER Hospitals, Hitec City<br />LUX Hospitals, Gachibowli</p></div>
              <div className="profile-detail" data-testid="profile-languages"><span className="detail-label">Speaks</span><p>English · Telugu · Hindi · Kannada</p></div>
            </div>
            <div className="profile-tags"><span>Advanced urology</span><span>Robotic surgery</span><span>Renal transplant</span></div>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
